import { COLORS, TYPOGRAPHY } from 'Components/foundation';
import { createStyleSheet } from 'Components/foundation/stylesheets';

export default createStyleSheet({
  container: {
    minWidth: 596,
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    paddingTop: '24px',
    backgroundColor: COLORS.WHITE.DEFAULT,
  },
  title: {
    ...TYPOGRAPHY.HERO_L_BOLD,
  },
  subtitle: {
    ...TYPOGRAPHY.H3,
    color: COLORS.TEXT.SECONDARY_DEFAULT,
  },
  gameplayContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'baseline',
    width: 650,
    marginTop: '16px',
    marginBottom: '24px',
  },
  gameplayHeader: {
    display: 'flex',
    flexFlow: 'column',
    marginBottom: 16,
  },
  iconRow: {
    display: 'flex',
    flexDirection: 'row',
    gap: '14px',
    marginBottom: 32,
  },
  gameplayType: {
    display: 'flex',
    flexDirection: 'column',
    minWidth: 345,
    paddingRight: 16,
  },
  gameplayButton: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  gameplayDescriptionContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
    minHeight: 85,
    marginBottom: 32,
  },
  gameplayTitle: {
    ...TYPOGRAPHY.H1_SEMIBOLD,
  },
  gameplayDescription: {
    ...TYPOGRAPHY.H3,
    color: COLORS.TEXT.SECONDARY_DEFAULT,
  },
  videoContainer: {
    width: '100%',
    backgroundColor: COLORS.WHITE.HOVER,
    marginBottom: 64,
  },
  pointsRow: {
    padding: '0 24px 16px 24px',
    display: 'flex',
    justifyContent: 'space-between',
    ...TYPOGRAPHY.H3,
    color: COLORS.TEXT.SECONDARY_DEFAULT,
  },
  rulesTitle: {
    ...TYPOGRAPHY.BODY4_BOLD,
    color: COLORS.TEXT.SECONDARY_DEFAULT,
    padding: '16px 24px 4px 24px',
  },
  rules: {
    maxWidth: '33%',
  },
  rulesPoints: {
    ...TYPOGRAPHY.BODY4,
    color: COLORS.TEXT.SECONDARY_DEFAULT,
  },
  rulesLabel: {
    ...TYPOGRAPHY.BODY4_SEMIBOLD,
    color: COLORS.TEXT.SECONDARY_DEFAULT,
  },
  rulesSubLabel: {
    ...TYPOGRAPHY.BODY4,
    color: COLORS.TEXT.SECONDARY_DEFAULT,
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
});
